import { useMemo } from 'react'
import { useCustomQueryWithParams } from 'shared/hooks/useCustomQueryWithParams.ts'
import { GET_CRYPTO_CURRENCIES } from '@/pages/Donation/api/constants.ts'
import { currenciesApi } from '@/pages/Donation/api'

export default function useCurrencyPrecision(code: string) {
  const { data } = useCustomQueryWithParams([GET_CRYPTO_CURRENCIES], () => currenciesApi.getCryptoCurrencies())

  const currencies = useMemo(() => {
    return data?.data?.reduce(
      (acc, currency) => {
        acc[currency?.code || ''] = currency?.precision || 0
        return acc
      },
      {} as Record<string, number>
    )
  }, [data?.data])

  return currencies?.[code] || 0
}
